import { lazy } from 'react';

const Register = lazy(() => import('./Register'));

export { Register };
